import AdminApi from '../../services/api'
import swal from 'sweetalert2'
import session from "../../services/session"
import CONFIG_COMPANY from "../../services/myConfig"
import Loc from "../../services/localization"

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: null,
            title: '',
            stockNumber: 0,
            companyInfoId: null,
            loaded: false,
            model: {
                orderNumber: 0,
                stockNumber: 0,
                name: '',
                enName: '',
                shortDescription: '',
                enShortDescription: '',
                longDescription: '',
                enLongDescription: '',
                imageHeader: null,
                imageMain: '',
                orderUuid: '',
                type: 'SHOP',
                price: null,
                category: null,
                discount: null,
                creditForUse: 1,
                isCreditType: false,
                additionalInfo: {
                    price: null,
                    currency: 'RSD',
                    discount: null,
                    shopLink: null
                },
                locations: null,
                isMainAdmin: false,
                isEnableAddStockNumber: false,
            },
        }
    },
    methods: {
        load: load,
        save: save,
        populateItemToEdit: populateItemToEdit,
        getCompanyInfoName: getCompanyInfoName,
        money(v, currencyValue) {
            return new Intl.NumberFormat('sr-RS', {
                style: 'currency',
                currency: currencyValue,
                minimumFractionDigits: 0
            }).format(v)
        },
        stockClass(p) {
            return p.stockNumber <= 0 ? 'oos' : (p.stockNumber <= p.lowStockThreshold ? 'low' : 'ok')
        },
        stockLabel(p) {
            return p.stockNumber <= 0 ? LocService.t('label_cart_not_on_stock') : (p.stockNumber <= p.lowStockThreshold ? `⚠ ${p.stockNumber}` : `${p.stockNumber}`)
        },
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME)
            return
        }

        this.id = this.$route.query.id
        this.companyInfoId = this.$route.query.id
        if (this.id == null) {
            this.title = LocService.t('label_warehouse_item_add_title')
        } else {
            this.title = LocService.t('label_warehouse_item_edit_title')
            this.load()
        }
    }
}

function load() {
    let _self = this;
    this.loaded = false;
    AdminApiService.getCompanyInfoById(this.id)
        .then((response) => {
            _self.populateItemToEdit(response)
            _self.loaded = true
        })
        .catch((error) => {
            _self.loaded = true
            swal(LocService.t('label_error'), LocService.t('label_error'), 'error')
        })
}

function populateItemToEdit(response){
    let _self = this;
    let addInfo = JSON.parse(response.data.additionalInfo)
    _self.imageUrl = response.data.imageMain
    _self.model.name = response.data.name
    _self.model.category = response.data.category
    _self.model.enName = response.data.enName
    _self.model.orderNumber = response.data.orderNumber
    _self.model.shortDescription = response.data.shortDescription
    _self.model.enShortDescription = response.data.enShortDescription
    _self.model.longDescription = response.data.longDescription
    _self.model.enLongDescription = response.data.enLongDescription
    _self.model.imageMain = response.data.imageMain
    _self.model.creditForUse = response.data.creditForUse
    _self.model.isCreditType = response.data.isCreditType
    _self.model.stockNumber = response.data.stockNumber != null ? response.data.stockNumber : 0;
    _self.model.additionalInfo.price = addInfo.price
    _self.model.additionalInfo.currency = addInfo.currency
    _self.model.additionalInfo.discount = addInfo.discount
    _self.model.additionalInfo.shopLink = addInfo.shopLink
    _self.selectedCustomCategories = response.data.locations == null ? [] : response.data.locations.split(";").filter(e => e.length > 0)
    _self.visibleStockNumber = (response.data.creditForUse <= 1 || response.data.isCreditType === true) && (this.isMainAdmin || this.isEnableAddStockNumber)
}

function save() {
    // u tvom WarehouseShopItem je stockNumber Integer (NotNull u requestu) – ovde ga držimo obaveznim
    if (this.stockNumber == null || this.stockNumber === 0) {
        swal(LocService.t('label_error'), LocService.t('label_all_field_required'), 'error')
        return
    }
    const model = {
        stockNumber: this.stockNumber,
        companyInfoId: this.companyInfoId
    }
    AdminApiService.addWarehouseShopItem(model)
        .then(() => {
            this.$router.push('/warehouses')
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getCompanyInfoName(item) {
    if (session.getLocale() === LocService.getDefaultLanguage()) {
        return item.name;
    } else if (item.enName != null && item.enName.length > 0) {
        return item.enName;
    }
    return item.name;
}



// WEBPACK FOOTER //
// ./src/components/Warehouse/AddEditWarehouseShopItem.js